export var NielsenSdkPlayheadEventTypes = /*#__PURE__*/ function(NielsenSdkPlayheadEventTypes) {
    NielsenSdkPlayheadEventTypes["LoadMetadata"] = "loadMetadata";
    NielsenSdkPlayheadEventTypes["SendID3"] = "sendID3";
    return NielsenSdkPlayheadEventTypes;
}({});

//# sourceMappingURL=nielsen-sdk.enums.js.map